module.exports = __webpack_public_path__ + "files/d12ceb8cad0758b7295491b78bff8a0f.png";